export const isOwner = (role) => role === "eigenaar";
export const isFinance = (role) => role === "financieel medewerker";
export const isOwnerOrFinance = (role) =>
    role === "eigenaar" || role === "financieel medewerker";
